import { useEffect, useRef } from 'react';

function useInterval(callback, interval, resetIntervalArr) {
  const callbackRef = useRef();
  const resetDeps = JSON.stringify(resetIntervalArr);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    function runCallback() {
      callbackRef.current();
    }
    if (Number.isInteger(interval)) {
      const id = setInterval(runCallback, interval);
      return () => clearInterval(id);
    }
  }, [interval, resetDeps]);
}

export default useInterval;
